// src/routes.js
import Dashboard from '@pages/Dashboard';
import Profile from '@pages/profile/Profile';
import Account from '@pages/account/Account';
import AccountAdd from '@pages/account/AccountAdd';
import AccountEdit from '@pages/account/AccountEdit';
import EmailConfig from '@pages/emailConfig/EmailConfig';
import EmailConfigAdd from '@pages/emailConfig/EmailConfigAdd';
import EmailConfigEdit from '@pages/emailConfig/EmailConfigEdit';
import LoginHistory from '@app/pages/report/countLogin/LoginHistory';
import StatisticLoginHistory from '@app/pages/report/countLogin/StatisticLoginHistory';
import Log from '@pages/log/Log';
import ApiRoleMapping from '@app/pages/apiRoleMapping/ApiRoleMapping';
import ApiRoleMappingAdd from '@app/pages/apiRoleMapping/ApiRoleMappingAdd';
import ApiRoleMappingEdit from '@app/pages/apiRoleMapping/ApiRoleMappingEdit';

import { URI_INTERNAL } from './utils/pathLocations';
import OpeniddictApplication from '@app/pages/openiddictApplication/OpeniddictApplication';
import OpeniddictApplicationAdd from '@app/pages/openiddictApplication/OpeniddictApplicationAdd';
import OpeniddictApplicationEdit from '@app/pages/openiddictApplication/OpeniddictApplicationEdit';
import RoleAccount from '@app/pages/roleAccount/RoleAccount';
import RoleAccountAdd from '@app/pages/roleAccount/RoleAccountAdd';
import RoleAccountEdit from '@app/pages/roleAccount/RoleAccountEdit';
import KySo from '@app/pages/kySo/KySo';
import SignedHuman from '@app/pages/signedHuman/SignedHuman';
import SignedHumanAdd from '@app/pages/signedHuman/SignedHumanAdd';
import SignedHumanEdit from '@app/pages/signedHuman/SignedHumanEdit';

// Common
import ChuDe from '@app/pages/appHuanLuyenDaoTao/common/chuDe/ChuDe';
import ChuDeAdd from '@app/pages/appHuanLuyenDaoTao/common/chuDe/ChuDeAdd';
import ChuDeEdit from '@app/pages/appHuanLuyenDaoTao/common/chuDe/ChuDeEdit';
import DanhMucPhanMem from '@app/pages/appHuanLuyenDaoTao/common/danhMucPhanMem/DanhMucPhanMem';
import DanhMucPhanMemAdd from '@app/pages/appHuanLuyenDaoTao/common/danhMucPhanMem/DanhMucPhanMemAdd';
import DanhMucPhanMemEdit from '@app/pages/appHuanLuyenDaoTao/common/danhMucPhanMem/DanhMucPhanMemEdit';
import ChuongTrinhHoc from '@app/pages/appHuanLuyenDaoTao/common/chuongTrinhHoc/ChuongTrinhHoc';
import ChuongTrinhHocAdd from '@app/pages/appHuanLuyenDaoTao/common/chuongTrinhHoc/ChuongTrinhHocAdd';
import ChuongTrinhHocEdit from '@app/pages/appHuanLuyenDaoTao/common/chuongTrinhHoc/ChuongTrinhHocEdit';
import ChuyenKhoa from '@app/pages/appHuanLuyenDaoTao/common/chuyenKhoa/ChuyenKhoa';
import ChuyenKhoaAdd from '@app/pages/appHuanLuyenDaoTao/common/chuyenKhoa/ChuyenKhoaAdd';
import ChuyenKhoaEdit from '@app/pages/appHuanLuyenDaoTao/common/chuyenKhoa/ChuyenKhoaEdit';
import ChuyenNganh from '@app/pages/appHuanLuyenDaoTao/common/chuyenNganh/ChuyenNganh';
import ChuyenNganhAdd from '@app/pages/appHuanLuyenDaoTao/common/chuyenNganh/ChuyenNganhAdd';
import ChuyenNganhEdit from '@app/pages/appHuanLuyenDaoTao/common/chuyenNganh/ChuyenNganhEdit';
import DanhMucVanBangChungChi from '@app/pages/appHuanLuyenDaoTao/common/danhMucVanBangChungChi/DanhMucVanBangChungChi';
import DanhMucVanBangChungChiAdd from '@app/pages/appHuanLuyenDaoTao/common/danhMucVanBangChungChi/DanhMucVanBangChungChiAdd';
import DanhMucVanBangChungChiEdit from '@app/pages/appHuanLuyenDaoTao/common/danhMucVanBangChungChi/DanhMucVanBangChungChiEdit';

// QuyTrinhTuyenSinh
import DangKyDuTuyen from '@app/pages/appHuanLuyenDaoTao/quyTrinhTuyenSinh/dangKyDuTuyen/DangKyDuTuyen';
import DangKyDuTuyenAdd from '@app/pages/appHuanLuyenDaoTao/quyTrinhTuyenSinh/dangKyDuTuyen/DangKyDuTuyenAdd';
import DangKyDuTuyenEdit from '@app/pages/appHuanLuyenDaoTao/quyTrinhTuyenSinh/dangKyDuTuyen/DangKyDuTuyenEdit';
import DotTuyenSinh from '@app/pages/appHuanLuyenDaoTao/quyTrinhTuyenSinh/dotTuyenSinh/DotTuyenSinh';
import DotTuyenSinhAdd from '@app/pages/appHuanLuyenDaoTao/quyTrinhTuyenSinh/dotTuyenSinh/DotTuyenSinhAdd';
import DotTuyenSinhEdit from '@app/pages/appHuanLuyenDaoTao/quyTrinhTuyenSinh/dotTuyenSinh/DotTuyenSinhEdit';

// CapNhatKienThucYKhoa (CME)
import CMEConfig from '@app/pages/appHuanLuyenDaoTao/capNhatKienThucYKhoa/cmeConfig/CMEConfig';
import CMEDictionary from '@app/pages/appHuanLuyenDaoTao/capNhatKienThucYKhoa/cmeDictionary/CMEDictionary';
import CMEDuyetHoSo from '@app/pages/appHuanLuyenDaoTao/capNhatKienThucYKhoa/duyetHoSo/CMEDuyetHoSo';
import CMEEvent from '@app/pages/appHuanLuyenDaoTao/capNhatKienThucYKhoa/cmeEvent/CMEEvent';
import CMEDashboard from '@app/pages/appHuanLuyenDaoTao/capNhatKienThucYKhoa/caNhan/CMEDashboard';
import CMEHoSo from '@app/pages/appHuanLuyenDaoTao/capNhatKienThucYKhoa/caNhan/CMEHoSo';
import CMEHoSoAdd from '@app/pages/appHuanLuyenDaoTao/capNhatKienThucYKhoa/caNhan/CMEHoSoAdd';
import CMEHoSoEdit from '@app/pages/appHuanLuyenDaoTao/capNhatKienThucYKhoa/caNhan/CMEHoSoEdit';

// QuanLyGPHN_CCHN
import PhamViHanhNghe from '@app/pages/appHuanLuyenDaoTao/quanLyGPHN_CCHN/phamViHanhNghe/PhamViHanhNghe';
import PhamViHanhNgheAdd from '@app/pages/appHuanLuyenDaoTao/quanLyGPHN_CCHN/phamViHanhNghe/PhamViHanhNgheAdd';
import PhamViHanhNgheEdit from '@app/pages/appHuanLuyenDaoTao/quanLyGPHN_CCHN/phamViHanhNghe/PhamViHanhNgheEdit';

import GiayPhepHanhNghe from '@app/pages/appHuanLuyenDaoTao/quanLyGPHN_CCHN/giayPhepHanhNghe/GiayPhepHanhNghe';
import GiayPhepHanhNgheAdd from '@app/pages/appHuanLuyenDaoTao/quanLyGPHN_CCHN/giayPhepHanhNghe/GiayPhepHanhNgheAdd';
import GiayPhepHanhNgheEdit from '@app/pages/appHuanLuyenDaoTao/quanLyGPHN_CCHN/giayPhepHanhNghe/GiayPhepHanhNgheEdit';
import DanhSachDuyetHoSo from '@app/pages/appHuanLuyenDaoTao/quanLyGPHN_CCHN/giayPhepHanhNghe/DanhSachDuyetHoSo';

const rawRoutes = [
  // dashboard
  {
    path: "/", // bạn có thể thêm HOME_PATH = '/'
    exact: true,
    component: Dashboard,
    isPublic: false,
    // label:      'Dashboard',
    controller: '',
    action: '',
    label: "Dashboard",
    menu: true,
    isPublic: false,
  },
  // profile
  {
    path: "/profile",
    exact: true,
    component: Profile,
    isPublic: false,
    // controller: 'Profile',
    // action:     'View',
    // label:      'Profile',
    controller: '',
    action: '',
    label: "Thông tin cá nhân",
    menu: false,
    isPublic: false,
  },
  // account
  {
    path: URI_INTERNAL.ACCOUNT_PATH,
    exact: true,
    component: Account,
    isPublic: false,
    controller: 'Account',
    // controller: '',
    action: '',
    label: "Tài khoản",
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.ACCOUNT_PATH_ADD,
    exact: true,
    component: AccountAdd,
    isPublic: false,
    // controller: 'Account',
    controller: '',
    action: '',
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.ACCOUNT_PATH_EDIT,
    exact: true,
    component: AccountEdit,
    isPublic: false,
    // controller: 'Account',
    controller: '',
    action: '',
    label: "",
    menu: false,
    isPublic: false,
  },
  //role
  {
    path: URI_INTERNAL.ROLE_ACCOUNT_PATH,
    exact: true,
    component: RoleAccount,
    isPublic: false,
    controller: 'Role',
    // controller: '',
    action: '',
    label: "Quyền",
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.ROLE_ACCOUNT_CREATE_PATH,
    exact: true,
    component: RoleAccountAdd,
    isPublic: false,
    // controller: 'Account',
    controller: '',
    action: '',
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.ROLE_ACCOUNT_EDIT_PATH,
    exact: true,
    component: RoleAccountEdit,
    isPublic: false,
    // controller: 'Account',
    controller: '',
    action: '',
    label: "",
    menu: false,
    isPublic: false,
  },
  // email config
  {
    path: URI_INTERNAL.EMAILCONFIG_PATH,
    exact: true,
    component: EmailConfig,
    isPublic: false,
    controller: 'EmailConfig',
    // controller: '',
    action: '',
    label: "Email gửi thông báo",
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.EMAILCONFIG_CREATE_PATH,
    exact: true,
    component: EmailConfigAdd,
    isPublic: false,
    // controller: 'EmailConfig',
    controller: '',
    action: '',
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.EMAILCONFIG_EDIT_PATH,
    exact: true,
    component: EmailConfigEdit,
    isPublic: false,
    // controller: 'EmailConfig',
    controller: '',
    action: '',
    label: "",
    menu: false,
    isPublic: false,
  },
  // reports
  {
    path: URI_INTERNAL.LOGIN_HISTORY_PATH,
    exact: true,
    component: LoginHistory,
    isPublic: false,
    controller: 'LoginHistory',
    // controller: '',
    action: '',
    label: "Lịch sử đăng nhập",
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.STATISTIC_HISTORY_PATH,
    exact: true,
    component: StatisticLoginHistory,
    isPublic: false,
    // controller: 'Report',
    controller: '',
    action: '',
    label: "Thống kê lịch sử đăng nhập",
    menu: true,
    isPublic: false,
  },
  // api-role-mapping
  {
    path: URI_INTERNAL.APIROLEMAPPING_PATH,
    exact: true,
    component: ApiRoleMapping,
    isPublic: false,
    controller: 'ApiRoleMapping',
    // controller: '',
    action: '',
    label: "Phân quyền API",
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.APIROLEMAPPING_CREATE_PATH,
    exact: true,
    component: ApiRoleMappingAdd,
    isPublic: false,
    // controller: 'ApiRoleMapping',
    // action:     'Them',
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.APIROLEMAPPING_EDIT_PATH,
    exact: true,
    component: ApiRoleMappingEdit,
    isPublic: false,
    // controller: 'ApiRoleMapping',
    // action:     'Sua',
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.OPENIDDICTAPPLICATION_PATH,
    exact: true,
    component: OpeniddictApplication,
    isPublic: false,
    controller: 'OpeniddictApplication',
    // controller: '',
    action: '',
    label: "Ứng dụng đăng ký",
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.OPENIDDICTAPPLICATION_CREATE_PATH,
    exact: true,
    component: OpeniddictApplicationAdd,
    isPublic: false,
    // controller: 'ApiRoleMapping',
    // action:     'Them',
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.OPENIDDICTAPPLICATION_EDIT_PATH,
    exact: true,
    component: OpeniddictApplicationEdit,
    isPublic: false,
    // controller: 'ApiRoleMapping',
    // action:     'Sua',
    label: "",
    menu: false,
    isPublic: false,
  },
  // log
  {
    path: URI_INTERNAL.LOG_PATH,
    exact: true,
    component: Log,
    isPublic: false,
    controller: 'Log',
    // controller: '',
    action: '',
    label: "Xem log",
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.KYSO_PATH,
    exact: true,
    component: KySo,
    isPublic: false,
    controller: 'KySo',
    // controller: '',
    action: '',
    label: "Ký số",
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.SIGNED_HUMAN_PATH,
    exact: true,
    component: SignedHuman,
    isPublic: false,
    controller: 'SignedHuman',
    // controller: '',
    action: '',
    label: "Người được ký",
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.SIGNED_HUMAN_CREATE_PATH,
    exact: true,
    component: SignedHumanAdd,
    isPublic: false,
    // controller: 'ApiRoleMapping',
    // action:     'Them',
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.SIGNED_HUMAN_EDIT_PATH,
    exact: true,
    component: SignedHumanEdit,
    isPublic: false,
    // controller: 'ApiRoleMapping',
    // action:     'Sua',
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.CHUDE_PATH,
    exact: true,
    component: ChuDe,
    isPublic: false,
    controller: 'ChuDe',
    action: '',
    label: "Chủ đề",
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.CHUDE_CREATE_PATH,
    exact: true,
    component: ChuDeAdd,
    isPublic: false,
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.CHUDE_EDIT_PATH,
    exact: true,
    component: ChuDeEdit,
    isPublic: false,
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.DANHMUCPHANMEM_PATH,
    exact: true,
    component: DanhMucPhanMem,
    isPublic: false,
    controller: 'DanhMucPhanMem',
    action: '',
    label: 'Danh mục phần mềm',
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.DANHMUCPHANMEM_CREATE_PATH,
    exact: true,
    component: DanhMucPhanMemAdd,
    isPublic: false,
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.DANHMUCPHANMEM_EDIT_PATH,
    exact: true,
    component: DanhMucPhanMemEdit,
    isPublic: false,
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.CHUONGTRINHHOC_PATH,
    exact: true,
    component: ChuongTrinhHoc,
    isPublic: false,
    controller: 'ChuongTrinhHoc',
    action: '',
    label: 'Chương trình học',
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.CHUONGTRINHHOC_CREATE_PATH,
    exact: true,
    component: ChuongTrinhHocAdd,
    isPublic: false,
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.CHUONGTRINHHOC_EDIT_PATH,
    exact: true,
    component: ChuongTrinhHocEdit,
    isPublic: false,
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.CHUYENKHOA_PATH,
    exact: true,
    component: ChuyenKhoa,
    isPublic: false,
    controller: 'ChuyenKhoa',
    action: '',
    label: 'Chuyên khoa',
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.CHUYENKHOA_CREATE_PATH,
    exact: true,
    component: ChuyenKhoaAdd,
    isPublic: false,
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.CHUYENKHOA_EDIT_PATH,
    exact: true,
    component: ChuyenKhoaEdit,
    isPublic: false,
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.CHUYENNGANH_PATH,
    exact: true,
    component: ChuyenNganh,
    isPublic: false,
    controller: 'ChuyenNganh',
    action: '',
    label: 'Chuyên ngành',
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.CHUYENNGANH_CREATE_PATH,
    exact: true,
    component: ChuyenNganhAdd,
    isPublic: false,
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.CHUYENNGANH_EDIT_PATH,
    exact: true,
    component: ChuyenNganhEdit,
    isPublic: false,
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.DANHMUCVANBANGCHUNGCHI_PATH,
    exact: true,
    component: DanhMucVanBangChungChi,
    isPublic: false,
    controller: 'DanhMucVanBangChungChi',
    action: '',
    label: 'Văn bằng chứng chỉ',
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.DANHMUCVANBANGCHUNGCHI_CREATE_PATH,
    exact: true,
    component: DanhMucVanBangChungChiAdd,
    isPublic: false,
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.DANHMUCVANBANGCHUNGCHI_EDIT_PATH,
    exact: true,
    component: DanhMucVanBangChungChiEdit,
    isPublic: false,
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.PHAMVIHANHNGHE_PATH,
    exact: true,
    component: PhamViHanhNghe,
    isPublic: false,
    controller: 'PhamViHanhNghe',
    action: '',
    label: 'Phạm vi hành nghề',
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.PHAMVIHANHNGHE_CREATE_PATH,
    exact: true,
    component: PhamViHanhNgheAdd,
    isPublic: false,
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.PHAMVIHANHNGHE_EDIT_PATH,
    exact: true,
    component: PhamViHanhNgheEdit,
    isPublic: false,
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.GIAYPHEPHANHNGHE_PATH,
    exact: true,
    component: GiayPhepHanhNghe,
    isPublic: false,
    controller: 'GiayPhepHanhNghe',
    action: '',
    label: 'Giấy phép hành nghề',
    menu: true,
    isPublic: false,
    hideForRoles: ['hldt_nhan_vien', 'phong_ke_hoach_tong_hop'],
  },
  {
    path: URI_INTERNAL.DANHSACHDUYETHOSO_PATH,
    exact: true,
    component: DanhSachDuyetHoSo,
    isPublic: false,
    controller: 'DanhSachDuyetHoSo',
    action: '',
    label: 'Danh sách duyệt hồ sơ',
    menu: true,
    isPublic: false,
    hideForRoles: ['app_giayphephanhnghe_access'],
  },
  {
    path: URI_INTERNAL.GIAYPHEPHANHNGHE_CREATE_PATH,
    exact: true,
    component: GiayPhepHanhNgheAdd,
    isPublic: false,
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.GIAYPHEPHANHNGHE_EDIT_PATH,
    exact: true,
    component: GiayPhepHanhNgheEdit,
    isPublic: false,
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.DANGKYDUTUYEN_PATH,
    exact: true,
    component: DangKyDuTuyen,
    isPublic: false,
    controller: 'DangKyDuTuyen',
    action: '',
    label: 'Đăng ký dự tuyển',
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.DANGKYDUTUYEN_CREATE_PATH,
    exact: true,
    component: DangKyDuTuyenAdd,
    isPublic: false,
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.DANGKYDUTUYEN_EDIT_PATH,
    exact: true,
    component: DangKyDuTuyenEdit,
    isPublic: false,
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.DOTTUYENSINH_PATH,
    exact: true,
    component: DotTuyenSinh,
    isPublic: false,
    controller: 'DotTuyenSinh',
    action: '',
    label: 'Đợt tuyển sinh',
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.DOTTUYENSINH_CREATE_PATH,
    exact: true,
    component: DotTuyenSinhAdd,
    isPublic: false,
    label: "",
    menu: false,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.DOTTUYENSINH_EDIT_PATH,
    exact: true,
    component: DotTuyenSinhEdit,
    isPublic: false,
    label: "",
    menu: false,
    isPublic: false,
  },
  // CME - Cap Nhat Kien Thuc Y Khoa
  {
    path: URI_INTERNAL.CMECONFIG_PATH,
    exact: true,
    component: CMEConfig,
    isPublic: false,
    controller: 'CMEAdmin',
    action: '',
    label: 'Cấu hình CME',
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.CMEEVENT_PATH,
    exact: true,
    component: CMEEvent,
    isPublic: false,
    controller: 'CMEKhoaDaoTao',
    action: '',
    label: 'Khóa đào tạo CME',
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.CMEDICTIONARY_PATH,
    exact: true,
    component: CMEDictionary,
    isPublic: false,
    controller: 'CMEAdmin',
    action: '',
    label: 'Danh mục CME',
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.CMEDUYETHOSO_PATH,
    exact: true,
    component: CMEDuyetHoSo,
    isPublic: false,
    controller: 'CMEAdmin',
    action: '',
    label: 'Phê duyệt CME',
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.CMEDASHBOARD_PATH,
    exact: true,
    component: CMEDashboard,
    isPublic: false,
    controller: 'CMEUser',
    action: '',
    label: 'Dashboard CME',
    menu: true,
    isPublic: false,
  },
  {
    path: URI_INTERNAL.CMECA_NHAN_PATH,
    exact: true,
    component: CMEHoSo,
    isPublic: false,
    controller: 'CMEUser',
    action: '',
    label: 'Lịch sử CME',
    menu: true,
    isPublic: false,
  },
  {
    path: `${URI_INTERNAL.CMECA_NHAN_PATH}/create`,
    exact: true,
    component: CMEHoSoAdd,
    isPublic: false,
    controller: 'CMEUser',
    action: '',
    label: '',
    menu: false,
  },
  {
    path: `${URI_INTERNAL.CMECA_NHAN_PATH}/edit/:id`,
    exact: true,
    component: CMEHoSoEdit,
    isPublic: false,
    controller: 'CMEUser',
    action: '',
    label: '',
    menu: false,
    isPublic: false,
  },
];

// function withController(routes) {
//   return routes.map(r => {
//     const name = r.component.displayName || r.component.name || '';
//     return {
//       ...r,
//       controller: r.controller ? r.controller : name,
//       // nếu chưa có label thì lấy tên component
//       label: r.label || name,
//     };
//   });
// }

function withController(routes) {
  return routes.map(r => ({
    ...r,
    // controller: r.controller,
    label: r.label || r.controller,
  }));
}

export const appRoutes = withController(rawRoutes);

export const menuGroups = [
  {
    title: "Danh mục chung",
    icon: "fas fa-cog",
    // Lấy tất cả route menu thuộc nhóm Hệ thống
    children: appRoutes.filter(r =>
      r.menu && [
        "ChuDe",
        "DanhMucPhanMem",
        "ChuongTrinhHoc",
        "ChuyenKhoa",
        "ChuyenNganh",
      ].includes(r.controller)
    )
  },
  {
    title: "Quản lý Giấy phép",
    icon: "fas fa-id-card",
    children: appRoutes.filter(r =>
      r.menu && [
        // "DanhMucVanBangChungChi",
        "PhamViHanhNghe",
        "GiayPhepHanhNghe",
        "DanhSachDuyetHoSo",
      ].includes(r.controller)
    )
  },
  {
    title: "Tích lũy CME",
    icon: "fas fa-graduation-cap",
    children: appRoutes.filter(r =>
      r.menu && [
        "CMEAdmin",
        "CMEUser",
        "CMEKhoaDaoTao"
      ].includes(r.controller)
    )
  },
   {
    title: "Quy trình tuyển sinh",
    icon: "fas fa-cog",
    // Lấy tất cả route menu thuộc nhóm Hệ thống
    children: appRoutes.filter(r =>
      r.menu && [
        "DangKyDuTuyen",
        "DotTuyenSinh"
      ].includes(r.controller)
    )
  },
  {
    title: "Chức năng",
    icon: "fas fa-cog",
    // Lấy tất cả route menu thuộc nhóm Hệ thống
    children: appRoutes.filter(r =>
      r.menu && [
        "SignedHuman",
        "KySo",
      ].includes(r.controller)
    )
  },
  {
    title: "Hệ thống",
    icon: "fas fa-cog",
    requireRoles: ['admin'],
    // Lấy tất cả route menu thuộc nhóm Hệ thống
    children: appRoutes.filter(r =>
      r.menu && [
        "Account",
        "Role",
        "EmailConfig",
        "ApiRoleMapping",
        "OpeniddictApplication",
        "Log",
      ].includes(r.controller)
    )
  },
  {
    title: "Báo cáo",
    icon: "fas fa-table",
    // Lấy tất cả route menu thuộc nhóm Báo cáo
    children: appRoutes.filter(r =>
      r.menu && [
        "LoginHistory",
        "StatisticLoginHistory"
      ].includes(r.controller)
    )
  },
];
